import { Alert } from '@apollo/orbit';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { JavascriptCodeBlock } from 'src/components/javascriptCodeBlock/JavascriptCodeBlock';

const exampleServerCode = `import { ApolloServerPluginInlineTrace } from "apollo-server-core";
const server = new ApolloServer({
  typeDefs,
  resolvers,
  plugins: [ApolloServerPluginInlineTrace()],
})`;
export const TracesInstructions = (props: { className?: string }) => {
  return (
    <div {...props}>
      Traces require Apollo Server version 2.18 or greater, that you have the{' '}
      <ClickableText
        className="text-link"
        as="a"
        href="https://www.apollographql.com/docs/apollo-server/api/plugin/inline-trace"
        target="__BLANK"
      >
        inline trace plugin
      </ClickableText>{' '}
      enabled, and that your endpoint accepts the{' '}
      <code>apollo-federation-include-trace</code> header.
      <JavascriptCodeBlock
        style={{ fontFamily: 'var(--font-mono)', fontSize: '11px' }}
        showLineNumbers={true}
        code={exampleServerCode}
      />
      <Alert status="warning" className="mt-3">
        Note that when this plugin is installed in your app, any client can
        request a trace for any operation they run, which may reveal information
        about your server that you consider sensitive (such as how long each
        individual field takes to execute).
      </Alert>
    </div>
  );
};
